module.exports = __webpack_public_path__ + "static/media/dashboard-workspace-app-application-layout-vertical-active.2fdf53bd.svg";